const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the content liked by component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('userEventSearch', ['Users','$q', function (Users, $q) {
  return {
    restrict: 'E',
    scope: {
      onQuery: '&',
      categories: '=',
      clear: '=',
      placeholder: '=',
      userList: '=?'
    },
    template: require('../../templates/directives/user-event-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      // Available query types: department|location|role|text|hired|created|active
      self.queryIds = {};
      self.queries = [];
      self.departments = {};
      self.locations = {};
      self.activeFilter = '';
      self.placeholder = $scope.placeholder;
      if (self.placeholder === undefined) {
        self.placeholder = 'modules.usersearch.placeholder';
      }

      var getLineage = function(id, type) {
        var items = [id];
        var children = [];
        var grandChildren = [];

        var addTo = function(id) {
          children.push(id);
          var main = self[type][id];
          if (!main || !main.children || !main.children.length) {
            return;
          }
          for (var i = 0; i < main.children.length; i++) {
            grandChildren.push(main.children[i]);
          }
        };

        if (!self[type][id] || !self[type][id].children || !self[type][id].children.length) {
          return items;
        }

        for (var i = 0; i < self[type][id].children.length; i++) {
          addTo(self[type][id].children[i], children);
        }

        return items.concat(children, grandChildren);
      };

      var textQuery = function(text) {
        return '15,full_name,$regex,2,' + text + ',i,job_title,$regex,2,' + text + ',i,email,$regex,2,' + text + ',i';
      };

      self.updateQuery = function() {
        var skills = [];
        var item = {};

        for (var i = 0; i < self.queries.length; i++) {
          switch (self.queries[i].type) {
            case 'location':
              var locations = getLineage(self.queries[i]._id, 'locations');
              item.linked_locations = '$in,' + locations.length + ',' + locations.join(',');
              break;
            case 'department':
              var departments = getLineage(self.queries[i]._id, 'departments');
              item.linked_departments = '$in,' + departments.length + ',' + departments.join(',');
              break;
            case 'user':
              item._id = self.queries[i]._id;
              break;
            case 'text':
              item['$or'] = textQuery(self.queries[i].name);
              break;
            default:
              break;
          }
        }
        $scope.onQuery({query: item});
      };

      self.makeLabel = function(type, value) {
        if (type === 'department' || type === 'location' || type === 'text' || type === 'role') {
          return value;
        }
      };

      self.removeUnique = function(type) {
        for (var i = 0; i < self.queries.length; i++) {
          if (self.queries[i].type === type) {
            var removed = self.queries.splice(i, 1);
            self.queryIds[removed[0]._id] = false;
            return;
          }
        }
      };

      self.outsideAdd = function(type, value) {
        self.removeUnique(type);
        var item = {
          name: self.makeLabel(type, value),
          text: value,
          _id: value + type,
          type: type
        };
        self.queries.push(item);
        self.addedTag(item, true);
      };

      // ------------- start ngTag triggered actions ------------
      self.addingTag = function($tag) {
        if ($tag.type && $tag.type !== 'user') {
          self.removeUnique($tag.type);
          return true;
        }
        if (Object.keys($tag).length === 1 && $tag.name) {
          $tag.text = $tag.name;
          $tag._id = $tag.name + '-text';
          $tag.type = 'text';
          self.removeUnique($tag.type);
          return true;
        }
        if ($tag.type && $tag.type === 'user') {
          self.queryIds = {};
          self.queries.splice(0);
          return true;
        }
      };

      self.addedTag = function($tag, outside) {
        if (!outside) {
          self.queryIds[$tag._id] = true;
        }
        self.updateQuery();
      };

      self.removedTag = function($tag) {
        self.queryIds[$tag._id] = false;
        self.updateQuery();
      };

      self.removeTags = function() {
         self.queries = [];
         self.updateQuery();
      };
      // ------------- End ngTag triggered actions ------------


      var legacyName = function(item, type) {
        var name = '';
        var parent;
        var parentName;
        var papa;
        var papaName;

        item.legacyName = item.name;

        if (item.parent) {
          parent = self[type][item.parent];
          parentName = parent.name + ' -> ';
          papa = parent.parent;
          item.legacyName = parentName + item.name;
        }

        if (papa) {
          papa = self[type][papa];
          papaName = papa.name + ' -> ';
          item.legacyName = papaName + parentName + item.name;
        }
      };

      self.sortCategories = function(data) {
        angular.forEach(data, function(cat) {
          if (cat.location) {
            self.locations[cat._id] = cat;
          }
          if (cat.department) {
            self.departments[cat._id] = cat;
          }
        });
        for (var loc in self.locations) {
          legacyName(self.locations[loc], 'locations');
        }
        for (var dep in self.departments) {
          legacyName(self.departments[dep], 'departments');
        }
      };

      self.getOptions = function(input) {
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';
        var usersPlaceholder = {name: 'Users', text: 'Users', _id: 'users', placeholder: true};
        var locationsPlaceholder = {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true};
        var departmentsPlaceholder = {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true};
        var addedItems = {
          users: false,
          locations: false,
          departments: false
        };

        var query = {
          page: 1,
          per_page: 6,
          fields: 'first_name,last_name,email,full_name,role,image,linked_departments,linked_locations',
          full_name: '$regex,2,' + input + ',i',
          sort: 'full_name,-1'
        };

        var usersRequest = !$scope.userList ? Users.find(query).$promise : Users.findFromSet(query, {users: $scope.userList}).$promise;

        usersRequest
        .then(function(users) {
          var items = [];

          // Add users to options
          for (var i = 0; i < users.length; i++) {
            if (!self.queryIds[users[i]._id]) {
              if (!addedItems.users) {
                items.push(usersPlaceholder);
                addedItems.users = true;
              }

              items.push({
                name: users[i].full_name,
                first_name: users[i].first_name,
                last_name: users[i].last_name,
                text: users[i].full_name,
                image: users[i].image,
                _id: users[i]._id,
                type: 'user'
              });
            }
          }

          // Add locations to options
          for (var loc in self.locations) {
            if (new RegExp(input).test(self.locations[loc].name.toLowerCase()) && !self.queryIds[self.locations[loc]._id]) {
              if (!addedItems.locations) {
                items.push(locationsPlaceholder);
                addedItems.locations = true;
              }
              items.push({
                name: self.locations[loc].name,
                text: self.locations[loc].legacyName,
                _id: self.locations[loc]._id,
                type: 'location'
              });
            }
          }
          for (var dep in self.departments) {
            if (new RegExp(input).test(self.departments[dep].name.toLowerCase()) && !self.queryIds[self.departments[dep]._id]) {
              if (!addedItems.departments) {
                items.push(departmentsPlaceholder);
                addedItems.departments = true;
              }
              items.push({
                name: self.departments[dep].name,
                text: self.departments[dep].legacyName,
                _id: self.departments[dep]._id,
                type: 'department'
              });
            }
          }

          deferred.resolve(items);
        });

        return deferred.promise;
      };

      self.initialize = function() {
        // Categories.find({
        //   $or: '4,location,true,department,true',
        //   sort: 'name,1'
        // }).$promise
        // .then(function(data) {
          // self.sortCategories(data);
        // });

        self.sortCategories($scope.categories);

      };

      if ($scope.categories) {
        self.initialize();
      } else {
        var catWatch = $scope.$watch('categories', function(newVal, oldVal) {
          if (newVal) {
            self.initialize();
            catWatch();
          }
        });
      }

      $scope.$watch('clear', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.removeTags();
          $scope.clear = false;
        }
      });
    }],
    controllerAs: 'search'
  }
}]);